import { FC, memo, Suspense } from 'react';
import { lazy } from 'utils/generic/lazy';
import { isMobile } from 'utils/is-mobile';
import { TBetBuilderStakeInputProps } from 'newcomponents/Shared/sportsbook/BetBuilderModal/components/BetBuilderStakeInput/types';

const { BetBuilderStakeInputDesktop } = lazy(
  () =>
    import(
      /* webpackChunkName: "BetBuilderStakeInputDesktop" */ 'newcomponents/Shared/sportsbook/BetBuilderModal/components/BetBuilderStakeInput/Desktop'
    )
);

const { BetBuilderStakeInputMobile } = lazy(
  () =>
    import(
      /* webpackChunkName: "BetBuilderStakeInputMobile" */ 'newcomponents/Shared/sportsbook/BetBuilderModal/components/BetBuilderStakeInput/Mobile'
    )
);

export const BetBuilderStakeInput: FC<TBetBuilderStakeInputProps> = memo(
  props => {
    return (
      <Suspense>
        {isMobile() ? (
          <BetBuilderStakeInputMobile {...props} />
        ) : (
          <BetBuilderStakeInputDesktop {...props} />
        )}
      </Suspense>
    );
  }
);
